/* eslint-disable react-hooks/exhaustive-deps */
import { useTranslation } from 'next-i18next'
import { UserSaleOffer } from 'src/core/models'
import { CheckOutlined } from '@ant-design/icons'
import { Button, Tooltip, Popconfirm } from 'antd'
import React, { useEffect, useState } from 'react'
import { CustomResultModal } from 'src/components'
import { useAppDispatch, useAppSelector, useWindowSize } from 'src/app/hooks'
import {
  resetAcceptSaleOfferState,
  acceptSaleOffferSelector,
  acceptUserSaleOffer,
} from 'src/features'

const SaleOfferAcceptButton: React.FC<{ offer: UserSaleOffer }> = ({ offer }) => {
  const { t } = useTranslation()
  const { isMobile } = useWindowSize()
  const dispatch = useAppDispatch()
  const [isModalVisible, setIsModalVisible] = useState(false)
  const { loading, success, currenctOfferId } = useAppSelector(acceptSaleOffferSelector)
  const isLoading = loading && offer.id === currenctOfferId
  const isOpen = offer.status === 'open'

  useEffect(() => {
    if (success && offer.id === currenctOfferId) {
      dispatch(resetAcceptSaleOfferState())
      setIsModalVisible(true)
    }
  }, [success])

  const acceptButton = <Button
    type='ghost'
    size='middle'
    shape='circle'
    className={'radius-100'}
    disabled={!isOpen || isLoading}
    loading={isLoading}
    icon={<CheckOutlined />}
  />

  return <>
    {isOpen ? (
      <Tooltip
        color='blue'
        placement='bottom'
        title={t('SalesOffer.AcceptOffer')}
      >
        <Popconfirm
          title={isMobile ? t('SalesOffer.AcceptX2') : t('SalesOffer.SureAccept')}
          onConfirm={() => dispatch(acceptUserSaleOffer(offer.id))}
          okText={t('general.Yes')}
          cancelText={t('general.Cancel')}
          cancelButtonProps={{ disabled: isLoading }}
          placement={'leftBottom'}
        >
          {acceptButton}
        </Popconfirm>
      </Tooltip>
    ) : <>{acceptButton}</>}

    {/* Accept Sale Modal results */}
    <CustomResultModal
      isModalVisible={isModalVisible}
      handleCancel={() => setIsModalVisible(false)}
      resultType='success'
      mainLabel={t('SalesOffer.AcceptedLabel')}
      extra={t('SalesOffer.RejectSubtitle')}
    />
  </>
}

export default SaleOfferAcceptButton
